import { useUpdateEffect } from "@Tmp/Hooks";
import clsx from "clsx";
import * as React from "react";
import { OdometerProps } from "./Odometer.types";

let Odo;

if (document) {
    //@ts-ignore
    Odo = require("odometer");
}

const Odometer: React.FC<OdometerProps> = ({ value, ...props }) => {
    const ref = React.useRef();
    const odometerRef = React.useRef<any>();

    //DONT CHANGE THIS STATE!
    //store the original value and never change it
    //this is only used to show a value until the odometer library has initialized
    //odometer will override the html so this is just used to store the original value
    //so react dont change the value after odometer has taken the control
    const [originalValue, setOriginalValue] = React.useState(value);

    React.useEffect(() => {
        odometerRef.current = new Odo({
            el: ref.current,
            value: value,

            // Any option (other than auto and selector) can be passed in here
            format: "(.ddd)",
        });
    }, [ref.current]);

    useUpdateEffect(() => {
        odometerRef.current?.update?.(value);
    }, [value]);

    return (
        <>
            <div className="tmp-odometer odometer odometer-auto-theme" ref={ref}>
                <div className="odometer-inside">
                    {Number(originalValue)
                        .toString()
                        .replace(/(.)(?=(\d{3})+$)/g, "$1.")
                        .split("")
                        .map((char, index) => (
                            <span
                                key={index}
                                className={clsx({
                                    "odometer-digit": char !== ".",
                                    "odometer-formatting-mark": char === ".",
                                })}
                            >
                                {char}
                            </span>
                        ))}
                </div>
            </div>
        </>
    );
};

export default Odometer;
